import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

//i18n
import { withTranslation } from 'react-i18next';
// Redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import { StoreContext } from '../../../hooks/useStore';
import { useAuth } from 'hooks/useAuth';


const ProfileMenu = (props) => {
  const { user } = useAuth();

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [name, setName] = useState('');

  const { state } = useContext(StoreContext);

  const role = state.user?.role || localStorage.getItem('shofco_role');
  const email = state.user?.email || localStorage.getItem('shofco_email');
  const userName = state.user?.name || localStorage.getItem('sname');

  // "SUPER_ADMIN" / "SuperAdmin" -> "SUPER ADMIN"
  const roleLabel = role
    ? String(role)
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .toUpperCase()
    : '';

  const initials = String(userName || email || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center gap-2"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-md-flex flex-column align-items-end text-end lh-sm">
            <span className="fw-semibold text-body">{userName}</span>
            {roleLabel && (
              <span className="text-muted font-size-11 letter-spacing-1">{roleLabel}</span>
            )}
          </span>
          <span
            className="rounded-circle bg-light text-body fw-semibold d-inline-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 36, height: 36, fontSize: 13 }}
            aria-label={userName}
          >
            {initials}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end" style={{ minWidth: '16rem' }}>
          <div className="px-3 py-2 lh-sm">
            <div className="fw-semibold text-body">{userName}</div>
            {email && <div className="text-muted font-size-12">{email}</div>}
            {roleLabel && <div className="text-muted font-size-11">{roleLabel}</div>}
          </div>
          <div className="dropdown-divider" />
          <DropdownItem tag="a" href="/profile">
            <i className="bx bx-user-circle font-size-16 align-middle me-2" />
            {props.t('Profile Settings')}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="bx bx-log-out font-size-16 align-middle me-2" />
            <span>{props.t('Logout')}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu)),
);
